import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-delete-gate',
  templateUrl: './delete-gate.component.html',
  styleUrl: './delete-gate.component.scss'
})

export class DeleteGateComponent {
  constructor(private _http: HttpClient, private router:Router) {}
  gateName: string = '';
  gateKey: string = '';
  gatesArray: any = [];
  selectedVenue: string = '';

  deleteGate(gateToDelete: string) {
    if (!gateToDelete) {
      console.error('Invalid gate to delete');
      return;
    }
    this.gatesArray = this.gatesArray.filter((gate: { value: string; }) => gate.value !== gateToDelete);
    const gateNames = this.gatesArray.map((gate: { value: any; }) => gate.value);
  
    const body = {
      venue: this.selectedVenue,
      gates: gateNames,
    };
  
    this._http
      .post(
        'https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/gates',
        body
      )
      .subscribe({
        next: (data) => {
          this.router.navigate(['tools/gates']);
        },
        error: (error) => {
        },
      });

  }


  

  ngOnInit() {
    const gate = history.state.gate;
    if (gate) {
      this.gateName = gate.value;
      this.gatesArray = history.state.gatesArray;
      this.selectedVenue = history.state.Selectedvenue;
    }
  }
}
